export const endPoints = {
  BLACKLIST: '/blacklist',
  BLACKLIST_ID: (id = '') => {
    return `/blacklist/${id}`
  },
  BLACKLIST_SAME: '/blacklist/same',
}
